module.exports = function() {
  return new Worker(__webpack_public_path__ + "792f889a03ad32b13c66.worker.js");
};